import { useEffect } from 'react';

/**
 * Custom hook to prevent browser refresh/close when condition is true
 * @param {boolean} when - Whether to show the browser's confirmation dialog
 */
export const useNavigationPrompt = (when) => {
  useEffect(() => {
    if (when) {
      const handleBeforeUnload = (e) => {
        // Trigger browser's generic confirmation dialog
        e.preventDefault();
        e.returnValue = '';
      };
      
      window.addEventListener('beforeunload', handleBeforeUnload);
      
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      };
    }
  }, [when]);
};
